import { Component, TemplateRef, ViewChild, Input } from '@angular/core';
import { NgBlockUI, BlockUI } from 'ng-block-ui';

@Component({
	selector: 'app-block-ui-wrapper',
	templateUrl: './block-ui-wrapper.component.html',
	styles: [
		`
    .custom-block-ui {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: rgba(255, 255, 255, 0.8);
      padding: 20px;
    }
    .spinner {
      border: 4px solid #f3f3f3;
      border-top: 4px solid #3498db;
      border-radius: 50%;
      width: 30px;
      height: 30px;
      animation: spin 1s linear infinite;
    }
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
    `
	]
})
export class BlockUIWrapperComponent {
	@Input() blockUIName: string = 'default';
	@BlockUI() blockUI!: NgBlockUI;
	@ViewChild('blockUITemplate') blockUITemplate!: TemplateRef<any>;

	ngOnInit() {
		console.log(this.blockUI); // Check if this.blockUI is defined
	}

	start(message?: string) {
		if (this.blockUI) {
			if (message) {
				this.blockUI.start(message); // Start with a custom message
			} else {
				this.blockUI.start(this.blockUITemplate); // Start with the custom template
			}
		} else {
			console.log(message);
		}
	}

	stop() {
		if (this.blockUI) {
			this.blockUI.stop();
		}
	}

	message(message?: string) {
		if (this.blockUI) {
			this.blockUI['message'](message);
		} else {
			console.log(message);
		}
	}
}
